import {jsx as $2M0TQ$jsx} from "react/jsx-runtime";
import "react";
import $2M0TQ$classnames from "classnames";




function $7b65bdcd60e7f9cc$export$88ef9d45f78c618f({ condition: condition , renderWrapper: renderWrapper , children: children  }) {
    return condition ? renderWrapper(children) : children;
}


function $befdc540191a524e$export$c6d4644fc812eb0a({ secondary: secondary = false , noPaddingTop: noPaddingTop = false , medium: medium = false , children: children1  }) {
    return /*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
        className: `svv-layout__banner ${(0, $2M0TQ$classnames)({
            "svv-layout__banner--primary": !secondary,
            "svv-layout__banner--secondary": secondary,
            "svv-layout__banner--no-padding-top": noPaddingTop
        })}`,
        children: /*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
            className: "svv-layout__content",
            children: /*#__PURE__*/ (0, $2M0TQ$jsx)((0, $7b65bdcd60e7f9cc$export$88ef9d45f78c618f), {
                condition: medium,
                // eslint-disable-next-line  @typescript-eslint/no-shadow
                renderWrapper: (children)=>/*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
                        className: "svv-layout__content__medium",
                        children: children
                    }),
                children: children1
            })
        })
    });
}





function $bbb7443027cba6e3$export$c5fbba3cd6b9d31b({ secondary: secondary = false , fullWidth: fullWidth = false , children: children  }) {
    return /*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
        className: `svv-layout__content ${(0, $2M0TQ$classnames)({
            "svv-layout__content--primary": !secondary,
            "svv-layout__content--secondary": secondary,
            "svv-layout__content--full-width": fullWidth
        })}`,
        children: children
    });
}




function $c1264890027e19c6$export$62766174043236da({ secondary: secondary = false , children: children  }) {
    return /*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
        className: `svv-layout__page-wrapper svv-layout__page-wrapper--${secondary ? "secondary" : "primary"}`,
        children: children
    });
}





function $d55694c475132cc5$export$fabad4343af30b48({ children: children1 , medium: medium = false , article: article = false  }) {
    return /*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
        className: "svv-layout__content",
        children: /*#__PURE__*/ (0, $2M0TQ$jsx)((0, $7b65bdcd60e7f9cc$export$88ef9d45f78c618f), {
            condition: medium,
            // eslint-disable-next-line  @typescript-eslint/no-shadow
            renderWrapper: (children)=>/*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
                    className: "svv-layout__content__medium",
                    children: children
                }),
            children: /*#__PURE__*/ (0, $2M0TQ$jsx)((0, $7b65bdcd60e7f9cc$export$88ef9d45f78c618f), {
                condition: article,
                // eslint-disable-next-line  @typescript-eslint/no-shadow
                renderWrapper: (children)=>/*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
                        className: "svv-layout__content__medium",
                        children: /*#__PURE__*/ (0, $2M0TQ$jsx)("div", {
                            className: "svv-layout__content__article",
                            children: children
                        })
                    }),
                children: children1
            })
        })
    });
}





export {$befdc540191a524e$export$c6d4644fc812eb0a as SVVLayoutBanner, $bbb7443027cba6e3$export$c5fbba3cd6b9d31b as SVVLayoutContent, $c1264890027e19c6$export$62766174043236da as SVVLayoutPageWrapper, $d55694c475132cc5$export$fabad4343af30b48 as SVVLayoutPageType, $7b65bdcd60e7f9cc$export$88ef9d45f78c618f as SVVConditionalWrapper};
//# sourceMappingURL=module.js.map
